import type { VersionInfo } from "./buildInfo";

export type UpdateStatus = "idle" | "update" | "urgent";

/** Identité du build qui tourne dans cet onglet (gravée par vite.config.ts). */
export function getLocalVersion(): VersionInfo {
  return {
    buildId: typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : "",
    urgency: typeof __BUILD_URGENCY__ === "number" ? __BUILD_URGENCY__ : 0,
  };
}

/**
 * Lit /version.json en contournant tout cache. Rend null au moindre écart
 * (réseau, 404, HTML servi à la place du JSON, forme inattendue) : un échec ne
 * doit jamais déclencher de recharge, on réessaie au tour suivant.
 */
export async function fetchRemoteVersion(
  fetchImpl: typeof fetch = fetch,
  now: number = Date.now(),
): Promise<VersionInfo | null> {
  try {
    const res = await fetchImpl(`/version.json?t=${now}`, { cache: "no-store" });
    if (!res.ok) return null;
    const data: unknown = await res.json();
    if (!data || typeof data !== "object") return null;
    const { buildId, urgency } = data as Record<string, unknown>;
    if (typeof buildId !== "string" || buildId === "") return null;
    if (typeof urgency !== "number" || !Number.isInteger(urgency) || urgency < 0) return null;
    return { buildId, urgency };
  } catch {
    return null;
  }
}

export function compareVersion(local: VersionInfo, remote: VersionInfo): UpdateStatus {
  if (!local.buildId || remote.buildId === local.buildId) return "idle";
  return remote.urgency > local.urgency ? "urgent" : "update";
}
